import { ApolloLink } from "@apollo/client";
import createSplitLinkObservable from "../../../internal/revamp/links/createSplitLinkObservable";
import { splitQueryByVariableValue } from "../../../internal/revamp/queryUtils/splitQueryByVariableValue";
export default function createVariableValueSplitLink(executionLink, variableSuffix, topLevelFields) {
    const contextSplitLink = new ApolloLink(function splitQueryByContextLink(operation) {
        var _operationContext_graphQlOperation;
        const operationContext = operation.getContext();
        const subQueriesWithVariables = splitQueryByVariableValue(operation.query, operation.variables, variableSuffix, topLevelFields, (_operationContext_graphQlOperation = operationContext.graphQlOperation) === null || _operationContext_graphQlOperation === void 0 ? void 0 : _operationContext_graphQlOperation.type);
        const executions = subQueriesWithVariables.map(({ subQuery, variables, containsNonNullableFields })=>{
            return {
                query: subQuery,
                link: executionLink,
                variables,
                containsNonNullableFields
            };
        });
        return createSplitLinkObservable(executions, operation);
    });
    return contextSplitLink;
}

//# sourceMappingURL=createVariableValueSplitLink.js.map